import { AxiosError } from "axios";
import axiosClient from "../utils/axiosClient";
import { useQuery } from "react-query";

export type CueItem = {
  type: "cue";
  data: {
    start: number;
    end: number;
    text: string;
  };
};

export type HeaderItem = {
  type: "header";
  data: string;
};

export type SubtitleJSONResponse = (HeaderItem | CueItem)[];

export const useSubtitleJson = (url?: string) => {
  return useQuery<any, AxiosError<any>, SubtitleJSONResponse>(
    ["subJson", url],
    () =>
      axiosClient.get<SubtitleJSONResponse>(url || "").then(({ data }) => data),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: !!url,
    }
  );
};
